import { ReflectionRoleEnum } from './reflection-role-enum'
import { ReflectionGenderEnum } from './reflection-gender-enum'
import { ReflectionStatusEnum } from './reflection-status-enum'

export interface ForegroundReflectionInterface {
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 学工号
   */
  usin?: string | null
  phone?: string | null
  email?: string | null
  /**
   * 个性头像
   */
  avatar?: string | null
  /**
   * 图片
   */
  photo?: string | null
  /**
   * 届别
   */
  graduate?: string | null
  /**
   * 所属科目
   */
  subject?: string | null
  /**
   * 注册时间
   */
  registedAt?: string | null
  /**
   * 生日
   */
  birthday?: string | null
  /**
   * 角色
   */
  role: ReflectionRoleEnum
  /**
   * 性别
   */
  gender?: ReflectionGenderEnum | null
  /**
   * 状态
   */
  status: ReflectionStatusEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class ForegroundReflection implements ForegroundReflectionInterface {
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 学工号
   */
  usin?: string | null
  phone?: string | null
  email?: string | null
  /**
   * 个性头像
   */
  avatar?: string | null
  /**
   * 图片
   */
  photo?: string | null
  /**
   * 届别
   */
  graduate?: string | null
  /**
   * 所属科目
   */
  subject?: string | null
  /**
   * 注册时间
   */
  registedAt?: string | null
  /**
   * 生日
   */
  birthday?: string | null
  /**
   * 角色
   */
  role: ReflectionRoleEnum
  /**
   * 性别
   */
  gender?: ReflectionGenderEnum | null
  /**
   * 状态
   */
  status: ReflectionStatusEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: ForegroundReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      account: _account,
      usin: _usin,
      phone: _phone,
      email: _email,
      avatar: _avatar,
      photo: _photo,
      graduate: _graduate,
      subject: _subject,
      registedAt: _registedAt,
      birthday: _birthday,
      role: _role,
      gender: _gender,
      status: _status,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.account = _account
    this.usin = _usin
    this.phone = _phone
    this.email = _email
    this.avatar = _avatar
    this.photo = _photo
    this.graduate = _graduate
    this.subject = _subject
    this.registedAt = _registedAt
    this.birthday = _birthday
    this.role = _role
    this.gender = _gender
    this.status = _status
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
